import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <Center h="100vh">
      <Stack align="center">
        <Title order={2}>Page not found</Title>
        <Text c="dimmed">That page does not exist.</Text>
        <Button component={Link} to="/" variant="light">
          Back to projects
        </Button>
      </Stack>
    </Center>
  );
}
